import MouseTrap, {ExtendedKeyboardEvent} from 'mousetrap';
import {useEffect} from 'react';

interface Options {
    disabled?: boolean;
    eventType?: 'keydown' | 'keyup' | 'keypress';
}

export const useKeyBind = <R extends (Element | null) | (Element | undefined)>(
    binding: string | string[],
    callback: (e: ExtendedKeyboardEvent, combo: string) => void,
    ref?: React.MutableRefObject<R>,
    {disabled, eventType}: Options = {}
) => {
    useEffect(() => {
        if (!disabled) {
            const mousetrap = new MouseTrap(ref?.current || undefined);
            const instance = mousetrap.bind(binding, callback, eventType);

            return () => {
                instance.unbind(binding, eventType);
            };
        }
    }, [binding, callback, ref, disabled, eventType]);
};
